import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TicketDetailsComponent } from './ticket-details/ticket-details.component';
import { TicketUebersichtComponent } from './ticket-uebersicht/ticket-uebersicht.component';
import { TicketUebersichtHistorieComponent } from './ticket-uebersicht/ticket-uebersicht-historie/ticket-uebersicht-historie.component';
import { TicketUebersichtOffeneComponent } from './ticket-uebersicht/ticket-uebersicht-offene/ticket-uebersicht-offene.component';

const routes: Routes = [
    {
        path: '',
        component: TicketUebersichtComponent,
        children: [
            { path: 'tickets', component: TicketUebersichtOffeneComponent },
            { path: 'tickets/:id', component: TicketDetailsComponent },
            { path: 'ticket-historie', component: TicketUebersichtHistorieComponent },
            { path: 'ticket-historie/:id', component: TicketDetailsComponent },
            { path: '**', redirectTo: 'tickets' },
        ],
    },
];

@NgModule({ declarations: [], imports: [RouterModule.forChild(routes)], exports: [RouterModule] })
export class TicketsystemRoutingModule {}
